import { create } from "zustand";
import { closeOtherModals, registerModalStore } from "./modal-registry";

/** Key this store is known by in the modal registry. */
const MODAL_NAME = "edit-color-collections";

export const useEditColorCollectionsStore = create((set) => ({
  isModalOpen: false,
  collectionId: null,
  isAddToCollection: false,
  addToCollectionUrl: null,
  openNewButtonModal: () => {
    closeOtherModals(MODAL_NAME);

    set({
      isModalOpen: true,
      collectionId: null,
      isAddToCollection: false,
      addToCollectionUrl: null,
    });
  },
  openNewCollectionFromModal: (addToCollectionUrl) => {
    closeOtherModals(MODAL_NAME);

    set({
      isModalOpen: true,
      collectionId: null,
      isAddToCollection: true,
      addToCollectionUrl,
    });
  },
  openExistingCollectionFromModal: (collectionId) => {
    closeOtherModals(MODAL_NAME);

    set({
      isModalOpen: true,
      collectionId,
      isAddToCollection: false,
      addToCollectionUrl: null,
    });
  },
  closeModal: () =>
    set({
      isModalOpen: false,
      collectionId: null,
      isAddToCollection: false,
      addToCollectionUrl: null,
    }),
  updateIsModalOpen: (isModalOpen) => set({ isModalOpen }),
}));

registerModalStore(MODAL_NAME, useEditColorCollectionsStore);
